import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { TargetNumberService } from 'src/api/v2';
import { SIVA_COMPANY_TARGET_NUMBERS } from 'src/constants/hook-keys';

const useCompanyTargetNumbers = (contractNumericId?: string, year?: number) => {
  const [service] = useState(() => new TargetNumberService());

  const targetNumbers = useQuery({
    queryFn: () => service.getGoalCategoriesWithTargetNumbersBySivaContract(Number(contractNumericId), year),
    enabled: !!contractNumericId && !!year,
    queryKey: [SIVA_COMPANY_TARGET_NUMBERS, Number(contractNumericId), year],
  });

  return {
    targetNumbers: targetNumbers.data,
    updatedAt: targetNumbers.dataUpdatedAt,
  };
};

export default useCompanyTargetNumbers;
